import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Page } from '@/components/layout/Page';
import { ErrorState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';
import { useDateFormat } from '@/features/company/api';

import { useCandidate } from '../api';
import { CandidateCreateForm } from '../components/CandidateCreateForm';
import { CandidateEditForm } from '../components/CandidateEditForm';

export function CandidateEditorPage() {
  const { id } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const dateFormat = useDateFormat();
  const candidate = useCandidate(id ?? '');
  const backTo = id ? `/candidates/${id}` : `/candidates${search}`;
  const close = () => {
    void navigate(backTo, { replace: true });
  };

  if (!id)
    return <CandidateCreateForm backTo={backTo} dateFormat={dateFormat} onClose={close} />;
  if (candidate.isPending)
    return (
      <Page>
        <Spinner label="Loading candidate" />
      </Page>
    );
  if (candidate.isError)
    return (
      <Page>
        <ErrorState
          message="The candidate could not be loaded."
          onRetry={() => {
            void candidate.refetch();
          }}
        />
      </Page>
    );
  return <CandidateEditForm key={id} candidate={candidate.data} onClose={close} />;
}
